import angular from 'angular';
import portaro from '../portaro';

portaro.directive('jpFocusWhen',
    function($timeout) {
        return {
            link: function(scope, element, attrs) {
                if (attrs.jpFocusWhen) {
                    scope.$watch(attrs.jpFocusWhen, function(val) {
                        if (angular.isDefined(val) && val) {
                            $timeout(function() {
                                element[0].focus();
                            });
                        }
                    }, true);

                    element.bind('blur', function() {
                        if (angular.isDefined(attrs.ngFocusLost)) {
                            scope.$apply(attrs.ngFocusLost);
                        }
                    });
                }
            }
        };
    });